'use client'
import { useContext, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { ModalsContext } from '@/context'

export const BaseUrlNavigationManager = () => {
	const { someModalIsActive } = useContext(ModalsContext)
	const pathname = usePathname()

	useEffect(() => {
		const html = document.body.parentElement
    html.style.overflow = someModalIsActive ? 'hidden' : 'initial'
	}, [pathname, someModalIsActive])

	return null
}